import React from 'react';
import { IconProps } from '../types';

const PlayIcon: React.FC<IconProps> = ({
  size = 24,
  color = 'currentColor',
  className = '',
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      className={className}
    >
      <path d="M8 5v14l11-7z" />
    </svg>
  );
};

export default PlayIcon;
